import { render, staticRenderFns } from "./SuppliesCard.vue?vue&type=template&id=5a28f060&"
import script from "./SuppliesCard.vue?vue&type=script&lang=js&"
export * from "./SuppliesCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports